// extracted by mini-css-extract-plugin
export default {"brands":"Brands_brands__W3vSG"};